import styled from 'styled-components';
import { useMatch, useResolvedPath } from 'react-router-dom';
import TabItem from './TabItem';

function TabNavs({ tabs, activeName, handleClick, noTranslation }) {
  return (
    <StyleUL className="nav" id="eventTab" role="tablist">
      {tabs.map((tab, index) => {
        let match = activeName === tab.title;
        if (tab.path) {
          let resolved = useResolvedPath(tab.path);
          match = useMatch({ path: resolved.pathname, end: true });
        }
        return (
          <TabItem
            title={tab.title}
            key={tab.title + index}
            isActive={match}
            className="fs-5"
            link={tab.path}
            noTranslation={noTranslation}
            handleClick={() => handleClick && handleClick(tab.title)}
          />
        );
      })}
      <HR />
    </StyleUL>
  );
}

export default TabNavs;

const StyleUL = styled.ul`
  position: relative;
`;
const HR = styled.hr`
  margin: 0;
  width: 100%;
  position: absolute;
  bottom: 0;
`;
